<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<section [attr.data-version]="version" class="slds-m-vertical_small">

  <svg:svg [attr.height]="layout.svgHeight"
           [attr.viewBox]="layout.svgViewBox"
           [attr.width]="layout.svgWidth"
           xmlns:svg="http://www.w3.org/2000/svg">
    <defs>
      <filter id="shadow">
        <feDropShadow dx="2" dy="2" stdDeviation="2"></feDropShadow>
      </filter>
    </defs>

    <g (blur)="onBlur($event)"
       (mousemove)="onMouseMove($event)"
       (mouseout)="onMouseOut($event)"
       [attr.transform]="layout.svgTransform"
       class="workbench"
       id="workbench">
      <!-- date header lines-->
      <ng-container *ngFor="let hdr of wb.headers">
        <g class="w-hdr">
          <ng-container *ngFor="let box of hdr.boxes">
            <rect [attr.data-i]="box.toString()"
                  [attr.fill]="box.fill"
                  [attr.height]="box.hh"
                  [attr.rx]="box.rxx"
                  [attr.ry]="box.ryy"
                  [attr.stroke]="box.stroke"
                  [attr.width]="box.ww"
                  [attr.x]="box.xx"
                  [attr.y]="box.yy"
                  class="w-hdr-box"></rect>
            <text [attr.x]="box.center"
                  [attr.y]="box.yy + (layout.lineHeight / 2)"
                  dominant-baseline="middle"
                  fill="gray"
                  text-anchor="middle">{{box.label}}</text>
          </ng-container>
        </g>
      </ng-container>

      <!-- pallet (project|resource) -->
      <ng-container *ngFor="let pallet of wb.pallets">
        <g [attr.data-display]="pallet.label"
           [attr.data-i]="pallet.toString()"
           class="w-pallet">
          <!-- pallet header -->
          <ng-container *ngFor="let line of pallet.summaries">
            <g [attr.data-display]="line.label"
               [attr.data-i]="line.toString()"
               class="sum-line">
              <ng-container *ngFor="let box of line.boxes">
                <rect [attr.data-i]="box.toString()"
                      [attr.fill]="box.fill"
                      [attr.height]="box.hh"
                      [attr.rx]="box.rxx"
                      [attr.ry]="box.ryy"
                      [attr.stroke]="box.stroke"
                      [attr.width]="box.ww"
                      [attr.x]="box.xx"
                      [attr.y]="box.yy"
                      class="sum-box"></rect>
                <text [attr.fill]="box.foreground"
                      [attr.x]="box.center"
                      [attr.y]="box.middle"
                      dominant-baseline="middle"
                      text-anchor="middle">{{box.label}}</text>
              </ng-container>
            </g>
          </ng-container>

          <!-- links -->
          <ng-container *ngFor="let link of pallet.links">
            <g class="w-link">
              <svg:polyline (click)="onClickLink(link, pallet)"
                            [attr.data-display]="link.label"
                            [attr.points]="link.points"
                            [attr.stroke]="link.stroke"
                            [id]="link.id"
                            fill="none"
                            stroke-width="2"
                            style="pointer-events: fill">
              </svg:polyline>
            </g>
          </ng-container>

          <!-- pallet crates (phase|project) -->
          <ng-container *ngFor="let crate of pallet.crates">
            <g [attr.data-i]="crate.toString()"
               class="w-crate">
              <g *ngIf="crate.showHeader" class="w-crate-hdr">
                <rect [attr.fill]="crate.fill"
                      [attr.height]="crate.hh"
                      [attr.rx]="crate.rxx"
                      [attr.ry]="crate.ryy"
                      [attr.stroke]="crate.stroke"
                      [attr.width]="crate.ww"
                      [attr.x]="crate.xx"
                      [attr.y]="crate.yy"></rect>
                <use (click)="crate.onClickToggle()"
                     *ngIf="crate.showToggle"
                     [attr.x]="crate.xx + 2"
                     [attr.xlink:href]="crate.arrowLink"
                     [attr.y]="crate.yy + 2"></use>
                <text [attr.x]="crate.xx + 35"
                      [attr.y]="crate.yy + layout.lineHeight"
                      font-style="oblique"
                      font-weight="bold">
                  {{crate.labelName}}
                </text>
              </g>

              <!-- main box - carton (project line)-->
              <ng-container *ngFor="let carton of crate.cartons">
                <g (click)="onClickCarton(carton, crate, pallet)"
                   (dblclick)="onClickDoubleCarton(carton)"
                   [attr.data-display]="carton.label + ' ' + carton.footer"
                   [attr.data-i]="carton.toString()"
                   [attr.data-id]="carton.recordId"
                   class="w-carton"
                   cursor="pointer">
                  <!--title>{{carton.label}}  {{carton.subLabel}}</title-->
                  <rect [attr.fill]="carton.fill"
                        [attr.height]="carton.hh"
                        [attr.rx]="carton.rxx"
                        [attr.ry]="carton.ryy"
                        [attr.stroke]="carton.stroke"
                        [attr.width]="carton.ww"
                        [attr.x]="carton.xx"
                        [attr.y]="carton.yy"
                        class="w-carton-r"
                        filter="url(#shadow)"></rect>
                  <text [attr.inline-size]="carton.ww - 10"
                        [attr.x]="carton.xx + 5"
                        [attr.y]="carton.yy + layout.lineHeight"
                        class="w-carton-label"
                        font-weight="bold"
                        style="text-overflow:ellipsis">
                    {{carton.label}}
                    <tspan dx="10" font-weight="normal">{{carton.subLabel}}</tspan>
                  </text>

                  <ng-container *ngFor="let line of carton.lines">
                    <g [attr.data-display]="line.label"
                       [attr.data-i]="line.toString()"
                       class="w-line">
                      <!--title>{{line.label}}</title-->
                      <ng-container *ngFor="let box of line.boxes">
                        <rect [attr.data-i]="box.toString()"
                              [attr.fill]="box.fill"
                              [attr.height]="box.hh"
                              [attr.rx]="box.rxx"
                              [attr.ry]="box.ryy"
                              [attr.stroke]="box.stroke"
                              [attr.width]="box.ww"
                              [attr.x]="box.xx"
                              [attr.y]="box.yy"
                              class="w-box"></rect>
                        <text [attr.fill]="box.foreground"
                              [attr.x]="box.center"
                              [attr.y]="box.middle"
                              dominant-baseline="middle"
                              text-anchor="middle">{{box.label}}</text>
                      </ng-container>
                    </g>
                  </ng-container>

                  <!-- footer (20 from bottom - text size usually 17) -->
                  <svg [attr.width]="carton.wwText(50)"
                       [attr.x]="carton.xx + 5"
                       [attr.y]="carton.yy + carton.hh - 20"
                       height="20">
                    <text class="w-carton-footer"
                          cursor="pointer"
                          dominant-baseline="central"
                          fill="gray"
                          x="0" y="10">
                      <!--title>{{carton.footer}}</title-->
                      {{carton.footer}}
                    </text>
                  </svg>
                  <svg>
                    <text [attr.x]="carton.xx + carton.ww - 5"
                          [attr.y]="carton.yy + carton.hh - 10"
                          class="w-carton-sfooter"
                          fill="gray"
                          font-style="oblique"
                          text-anchor="end">
                      <!--title>Duration {{carton.subFooter}}d</title-->
                      {{carton.subFooter}}d
                    </text>
                  </svg>
                </g><!-- carton -->
              </ng-container>
            </g><!-- crate -->
          </ng-container>
        </g><!-- pallet -->
      </ng-container>

      <g class="tooltip" id="tooltip" visibility="hidden">
        <rect fill="white" filter="url(#shadow)" height="20" rx="2" ry="2" stroke="#1589ee" width="80" x="2" y="2"/>
        <text x="6" y="16">tt</text>
      </g>
    </g>
  </svg:svg>

</section>

